import {Selectable} from '../../../../core/interfaces/selectable.interface';
import {AvailableVehicleCategory} from '../enum/available-vehicle-category.enum';
import {AvailableVehicleUsageType} from '../enum/available-vehicle-usage-type.enum';

export class VehicleCategory implements Selectable<VehicleCategory> {
  constructor(
    public readonly category: AvailableVehicleCategory,
    public readonly name: string,
  ) {
  }

  get value(): this {
    return this;
  }

  toSelectText(): string {
    return this.name;
  }

  toSelectDescription?(): string {
    return `Zaznaczono: ${this.category}`;
  }

  get displayName(): string {
    return this.name;
  }
}
